import { service } from '@/ajax/request'

// 代理用户信息
export interface UserProxy {
    desc: String,
    memberId: Number,
    name: String
}


// 根据用户名或姓名分页获取用户列表
export const userProxyList = () => (
    service({
        url: '/member//proxy/list',
        method: 'GET',
    })
)


// 修改指定用户信息
export const saveUserProxy = (params: any) => (
    service({
        url: `/member/proxy/save`,
        method: 'POST',
        params
    })
)